import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Bridge from "./pages/Bridge";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/bridge" element={<Bridge />} />
    </Routes>
  );
}

export default App;
